import React from 'react';
import { connect } from 'react-redux';
import '../../../styles/screens/nyumba.scss';
import { say, alert, preloaderShow, preloaderHide } from "../../../actions";
import { config } from "../../../app/config";
import TranslationService from "../../../app/services/TranslationService";

const icons = {
    0: 'imd-icon imd-icon-nyumba',
    1: 'imd-icon imd-icon-smartphone-device\n',
    2: 'imd-icon imd-icon-globe',
    3: 'imd-icon imd-icon-user-circle',
    4: 'imd-icon imd-icon-headset',
    5: 'imd-icon imd-icon-modern-tv',
    6: 'imd-icon imd-icon-google-circle',
    7: 'imd-icon imd-icon-sun-light ',
    8: 'imd-icon imd-icon-modern-tv',
    9: 'imd-icon imd-icon-globe',
    10: 'svg xiaomi_mi_home',
    11: 'imd-icon imd-icon-electronics-chip',
    12: 'imd-icon imd-icon-ev-plug',
    13: 'imd-icon imd-icon-puzzle',
    14: 'imd-icon imd-icon-podcast',
    15: 'imd-icon imd-icon-droplet',
    16: 'imd-icon imd-icon-fire-flame',
    17: 'imd-icon imd-icon-fire-flame',
    18: 'imd-icon imd-icon-temperature-low',
    19: 'imd-icon imd-icon-bonfire',
    20: 'imd-icon imd-icon-hexagon-dice',
    21: 'imd-icon imd-icon-electronics-chip',
    22: 'imd-icon imd-icon-database',
    23: 'imd-icon imd-icon-light-bulb',
    24: 'imd-icon imd-icon-puzzle',
    25: 'imd-icon imd-icon-sun-light',
    26: 'imd-icon imd-icon-podcast',
    27: 'nyumba|{"margin": "-15px 0 0 0"}',
    28: 'imd-icon imd-icon-ev-plug',
    29: 'imd-icon imd-icon-fire-flame',
    30: 'imd-icon imd-icon-minus-square,imd-icon imd-icon-square,imd-icon imd-icon-plus-square|{"transform": "rotate(90deg)", "margin": "5px 10px -10px -10px"}',
    1300: 'svg icymat'
}

const allowedActions = {
    '4': {
        'play_radio': 'imd-icon imd-icon-play',
        'play_stop': 'imd-icon imd-icon-square'
    },
    '12': {
        'plug': null
    },
    '22': {
        'scale': 10
    },
    '25': {
        'rgb color 255 255 255 128': 'imd-text-white imd-icon imd-icon-plus-circle-solid',
        'off': 'imd-icon imd-icon-circle',
    },
    '26': {
        'pir': null
    },
    '27': {
        'play_radio': 'imd-icon imd-icon-play',
        'play_stop': 'imd-icon imd-icon-square'
    },
    '29': {
        'off': 'imd-icon imd-icon-switch-off'
    },
    '30': {
        'switch': null
    }
};

export class NyumbaDevicesList extends React.Component
{
    prepareDevicesObject = () => {
        let rooms = {};
        let objectByRooms = {};

        Object.keys(this.props.devices).forEach(deviceId => {
            let device = this.props.devices[deviceId];

            let roomName = device.room === null ? TranslationService.trans(this.props.language, 'nyumba.devices.unknown_devices') : device.room.name;
            let roomOrder = device.room === null ? 100000 : device.room.order;

            if (rooms[roomName] === undefined) {
                rooms[roomName] = [roomName, roomOrder];
            }
        });

        rooms = Object.values(rooms);
        rooms.sort(function(a, b) {
            return a[1] - b[1];
        });
        rooms.forEach(room => {
            objectByRooms[room[0]] = [];
        })

        Object.keys(this.props.devices).forEach(deviceId => {
            let device = this.props.devices[deviceId];

            let roomName = device.room === null ? TranslationService.trans(this.props.language, 'nyumba.devices.unknown_devices') : device.room.name;

            objectByRooms[roomName].push(device);
        });

        return objectByRooms;
    }

    renderDevices = (devices) => {
        const currentDate = new Date();
        const timestamp = Math.round(currentDate.getTime() / 1000);

        return (
            <div className={"imd-row"}>
                {
                    Object.keys(devices).map(id => {
                        let device = devices[id];
                        let iconClass = icons[device.type.id] === undefined ? icons[1] : icons[device.type.id];

                        let temp = iconClass.split('|');
                        iconClass = temp[0];
                        iconClass = iconClass.split(',');
                        let iconIndex = 0;

                        if (device.hasOwnProperty('icon') >= 0 && device.icon !== null) {
                            if (device.icon.hasOwnProperty('alternative')) {
                                iconIndex = device.icon.alternative;
                            }
                        }

                        iconClass = iconClass[iconIndex];

                        let iconFilters = {};
                        if (temp.length > 1) {
                            iconFilters = JSON.parse(temp[1]);
                        }
                        iconFilters.height = '50px';

                        if (device.type.id <= 3 || device.type.name === 'TYPE_UNKNOWN_DEVICE' || (config.env !== 'dev' && Math.abs(timestamp - device.last_report) > 15 * 60)) {
                            return (<span />);
                        }

                        return (<div key={id} className={'imd-col-xs-12 imd-col-md-6 imd-col-lg-3'}>
                            <div className={'imd-shadow-dark imd-text-white device'} style={{margin: '7px', padding: '13px'}}>
                                <div className={"icon-container"}>
                                    {this.renderDeviceIcon(device, iconClass, iconFilters)}
                                </div>
                                <div className={"properties-container"}>
                                    <span className={'name'}>{device.custom_name !== null && device.custom_name !== '' ? device.custom_name : device.name}</span>

                                    {this.renderDeviceActions(device)}
                                </div>
                            </div>
                        </div>)
                    })
                }
            </div>
        );
    }

    renderDeviceIcon = (device, iconClass, iconFilters) => {
        if (iconClass === 'nyumba') {
            return (<span className={'icon icymat nyumba imd-text-150-silver'} style={iconFilters} />);
        } else if (iconClass === 'xiaomi') {
            iconFilters.height = '50px';
            return (<img src={'images/nyumba/icons/xiaomi.png'} alt="Nyumba" style={iconFilters} />);
        }

        return (<span className={"icon imd-text-150-silver " + iconClass} style={iconFilters} />);
    }

    renderDeviceActions = (device) => {
        if (!allowedActions.hasOwnProperty(device.type.id)) {
            return (<div className={'actions'}></div>);
        }

        const actions = allowedActions[device.type.id];
        let that = this;

        return (
            <div className={'actions'}>
                {
                    Object.keys(actions).map(action => {
                        if (action === 'scale') {
                            let scale = [0];
                            for (let x = 1; x <= actions[action]; x++) {
                                scale.push(x);
                            }

                            return (<span>
                                {
                                    Object.keys(scale).map(x => {
                                        return (
                                            <span
                                                style={{marginLeft: '3px', cursor: 'pointer'}}
                                                className={x > 0 ? 'imd-text-green' : 'imd-text-red'}
                                                onClick={() => that.props.sendAction('DEVICE: ' + device.id + ' set ' + x)}>
                                                {x}
                                            </span>
                                        )
                                    })
                                }
                            </span>)
                        }

                        if (action === 'switch' && device.property !== null && device.property.length > 1 && device.property[0] === 'switches') {
                            let propertyKeys = Object.keys(device.property[1]);
                            if (Object.keys(device).indexOf('customization') >= 0 && device.customization !== null && device.customization.hasOwnProperty('reverse_switch_displaying')) {
                                propertyKeys = propertyKeys.reverse();
                            }

                            return (
                                <span>
                                    {
                                        propertyKeys.map(x => {
                                            return (
                                                <span
                                                    style={{marginRight: '10px', cursor: 'pointer', fontSize: '1.5rem'}}
                                                    className={(device.property[1][x] === '0' ? 'imd-text-160-silver' : 'imd-text-30-blue') + ' imd-icon imd-icon-circle'}
                                                    onClick={() => that.props.sendAction('DEVICE: ' + device.id + ' switch ' + (device.property[1][x] === '0' ? 'on' : 'off') + ' ' + x)}>
                                            </span>
                                            )
                                        })
                                    }
                                </span>
                            );
                        }

                        if (action === 'plug' && device.property !== null && device.property.length > 1 && device.property[0] === 'status') {
                            return (
                                <span
                                    style={{fontSize: '2rem', cursor: 'pointer'}}
                                    className={(device.property[1] === '1' ? 'imd-icon-switch-on' : 'imd-icon-switch-off') + ' imd-icon imd-text-silver'}
                                    onClick={() => that.props.sendAction('DEVICE: ' + device.id + ' ' + (device.property[1] === '0' ? 'on' : 'off'))}>
                                </span>
                            );
                        }

                        if (action === 'pir' && device.property !== null && device.property.length > 1 && device.property[0] === 'status') {
                            return (
                                <span
                                    style={{fontSize: '1.5rem'}}
                                    className={(device.property[1] === '1' ? 'imd-text-green imd-icon-walking' : 'imd-text-red imd-icon-walking') + ' imd-icon'}>
                                </span>
                            );
                        }

                        const icon = actions[action];

                        return (<button
                            className={'imd-text-accent'}
                            style={{fontSize: '1.5rem', border: 'none', background: 'none', padding: 0, cursor: 'pointer'}}
                            onClick={() => that.props.sendAction('DEVICE: ' + device.id + ' ' + action)}
                        >
                            <span className={icon}></span>
                        </button>)
                    })
                }
            </div>
        );
    }

    render = () => {
        const devices = this.prepareDevicesObject();

        return (
            <div>
                {
                    Object.keys(devices).map(name => {
                        return (
                            <div className={"imd-container-fluid"}>
                                <div className={"imd-row"}>
                                    <div className={"imd-col-xs-12"}>
                                        <h2 className={"imd-text-accent"}>{name}</h2>
                                    </div>
                                </div>

                                {this.renderDevices(devices[name])}
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        language: TranslationService.getLanguage(state.user),
        view: state.view
    }
};

const mapDispatchToProps = {
    say,
    alert,
    preloaderShow,
    preloaderHide
};

export const DevicesList = connect(mapStateToProps, mapDispatchToProps)(NyumbaDevicesList);
